export default {
  vendors_active: (state) => state.vendors_active,
  vendors_inactive: (state) => state.vendors_inactive,
  vendors_pending: (state) => state.vendors_pending,
  vendors_rejected: (state) => state.vendors_rejected,
  vendors_disabled: (state) => state.vendors_disabled,
  account_managers: (state) => state.account_managers,
  vendors_summary: (state) => state.vendors_summary,
};
